import { render } from "./Directions.vue?vue&type=template&id=4470ea15"
import script from "./Directions.vue?vue&type=script&lang=js"
export * from "./Directions.vue?vue&type=script&lang=js"

import exportComponent from "C:\\task\\cottontriviagame\\markup\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__